import CloseIcon from '@mui/icons-material/Close';
import type {SxProps} from '@mui/material';
import Stack from '@mui/material/Stack';
import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type {FC, ReactElement} from 'react';
import {Popup} from 'react-map-gl/maplibre';

//TYPES
type Props = {
  key: string;
  longitude: number;
  latitude: number;
  title?: string;
  children: ReactElement;
  onClose?: () => void;
};

const CustomPopUp: FC<Props> = ({key, longitude, latitude, title, children, onClose}) => {
  return (
    <StyledPopup key={key} anchor="left" closeButton={false} longitude={longitude} latitude={latitude}>
      <Stack direction="row" sx={styles.titleContainer}>
        {title && (
          <Typography sx={styles.title} variant="overline">
            {title}
          </Typography>
        )}
        {onClose && <CloseIcon sx={{color: 'common.white'}} onClick={onClose} />}
      </Stack>
      <Stack sx={styles.children}>{children}</Stack>
    </StyledPopup>
  );
};
export default CustomPopUp;

const StyledPopup = styled(Popup)(
  `
    && .maplibregl-popup-content {
      padding: 0;
      margin: 0;
      border-radius: 0;
    }
  `,
);

const styles: Record<string, SxProps> = {
  titleContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',
    bgcolor: 'primary.main',
    p: 1,
    minWidth: '225px',
  },
  title: {
    fontWeight: 700,
    color: 'common.white',
  },
  children: {
    m: 1,
  },
  action: {
    m: 1,
  },
};
